/* ============================================================
   CANVAS CASE — custom scripts (cc-custom.js)
   Loaded after the theme's own JS. Self-contained; no theme deps.
   ============================================================ */

/* ---- Product description accordions ----
   Replaces the expired accordion app. Finds each <h5> inside
   .product__description and turns it into a collapsible section:
   the header toggles the content that follows it (until the next
   <h5>). All sections start closed. Accessible + idempotent. */
(function () {
  'use strict';

  var CARET =
    '<svg class="cc-acc__caret" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false">' +
    '<path d="M5 7.5 10 12.5 15 7.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var uid = 0;

  function isH5(node) {
    return node && node.nodeType === 1 && node.tagName === 'H5';
  }

  function setOpen(acc, open) {
    var header = acc.querySelector('.cc-acc__header');
    var panel = acc.querySelector('.cc-acc__panel');
    if (!header || !panel) return;
    if (open) {
      acc.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      acc.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
      // Pin current height, force reflow, then collapse so it animates.
      panel.style.maxHeight = panel.scrollHeight + 'px';
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;
      panel.style.maxHeight = '0px';
    }
  }

  function toggle(acc) {
    setOpen(acc, !acc.classList.contains('is-open'));
  }

  function build(container) {
    // Skip if already processed (done or skipped).
    if (!container || container.getAttribute('data-cc-acc')) return;

    var children = Array.prototype.slice.call(container.children);
    if (!children.some(isH5)) {
      container.setAttribute('data-cc-acc', 'skip');
      return;
    }

    // Group: each <h5> plus the siblings after it, up to the next <h5>.
    // Any nodes before the first <h5> are left untouched.
    var groups = [];
    var current = null;
    children.forEach(function (node) {
      if (isH5(node)) {
        current = { header: node, content: [] };
        groups.push(current);
      } else if (current) {
        current.content.push(node);
      }
    });

    groups.forEach(function (g) {
      uid += 1;
      var panelId = 'cc-acc-panel-' + uid;

      var acc = document.createElement('div');
      acc.className = 'cc-acc';

      var panel = document.createElement('div');
      panel.className = 'cc-acc__panel';
      panel.id = panelId;
      panel.style.maxHeight = '0px';

      var inner = document.createElement('div');
      inner.className = 'cc-acc__inner';

      // Place the wrapper where the header currently is.
      container.insertBefore(acc, g.header);

      // Convert the <h5> into the clickable header.
      var header = g.header;
      header.classList.add('cc-acc__header');
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', 'false');
      header.setAttribute('aria-controls', panelId);

      // Wrap the existing (possibly messy) heading content in a title span,
      // then append the caret. Empty tags/whitespace stay harmless inside.
      var title = document.createElement('span');
      title.className = 'cc-acc__title';
      while (header.firstChild) {
        title.appendChild(header.firstChild);
      }
      header.appendChild(title);
      header.insertAdjacentHTML('beforeend', CARET);

      // Assemble: header + panel(inner(content)) into the accordion.
      acc.appendChild(header);
      g.content.forEach(function (node) {
        inner.appendChild(node);
      });
      panel.appendChild(inner);
      acc.appendChild(panel);

      header.addEventListener('click', function () {
        toggle(acc);
      });
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle(acc);
        }
      });
    });

    container.setAttribute('data-cc-acc', 'done');
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.product__description');
    Array.prototype.forEach.call(nodes, build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Rebuild when Shopify re-renders a section (theme editor).
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });

  // Keep any open panel correctly sized if the viewport width changes.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var open = document.querySelectorAll('.cc-acc.is-open .cc-acc__panel');
      Array.prototype.forEach.call(open, function (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
      });
    }, 150);
  });
})();
